<template>
  <div class="px-2 p-md-0">
    <div v-for="post in posts" :key="post.Id">
      <PostListerItem :post="post"/>
    </div>
  </div>
</template>

<script>
import PostListerItem from '@/components/Posts/Lister/PostListerItem'
import axios from 'axios'

export default {
  name: 'PostLister',
  components: {
    PostListerItem
  },
  data () {
    return {
      posts: []
    }
  },
  created () {
    this.getPosts()
  },
  methods: {
    async getPosts () {
      let response = []
      try {
        response = await axios.get(`/posts`)
      } catch (error) {
        return
      }

      this.posts = response.data
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Posts/Lister/PostLister.vue